<template>
  <div style="height: 400px">
    <GridVx
      ref="agGrid"
      dom-layout="scroll"
      :columns="columns"
      :rows="bookingDetailStore.booking_traveller"
      row-selection="single"
      class="agGrid"
    />
  </div>
</template>

<script>
import { bookingDetailStore } from '../stores/'
// eslint-disable-next-line no-unused-vars
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckboxReadonly
  },
  data() {
    return {
      columns: [
        {
          headerName: 'Họ',
          field: 'last_name',
          tooltipField: 'last_name',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          maxWidth: 150,
          sortable: false
        },
        {
          headerName: 'Tên',
          field: 'first_name',
          tooltipField: 'first_name',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          maxWidth: 150,
          sortable: false
        },
        {
          headerName: 'Khách chính',
          field: 'is_master',
          cellRenderer: 'CellRenderCheckboxReadonly',
          cellClass: 'grid-cell-align-center',
          // flex: 1
          minWidth: 120,
          maxWidth: 120,
          sortable: false
        },
        // {
        //   headerName: 'Trẻ em',
        //   field: 'is_child',
        //   cellRenderer: 'CellRenderCheckboxReadonly',
        //   // cellClass: 'grid-cell-centered',
        //   // flex: 1
        //   minWidth: 150,
        //   sortable: false
        // },
        // {
        //   headerName: 'Ngày đến',
        //   field: 'arrive_date',
        //   tooltipField: 'arrive_date',
        //   // cellClass: 'grid-cell-centered',
        //   // flex: 1
        //   minWidth: 150,
        //   sortable: false
        // },
        // {
        //   headerName: 'Ngày đi',
        //   field: 'depart_date',
        //   tooltipField: 'depart_date',
        //   // cellClass: 'grid-cell-centered',
        //   // flex: 1
        //   minWidth: 150,
        //   sortable: false
        // },
        {
          headerName: 'Số điện thoại',
          field: 'phone_number',
          tooltipField: 'phone_number',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 180,
          maxWidth: 180,
          sortable: false
        },
        {
          headerName: 'Ghi chú',
          field: 'note',
          tooltipField: 'note',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 200,
          sortable: false
        },

        {
          headerName: 'Email',
          field: 'email',
          tooltipField: 'email',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 180,
          maxWidth: 180,
          sortable: false
        },
        {
          headerName: 'Địa chỉ',
          field: 'address_1',
          tooltipField: 'address_1',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 180,
          maxWidth: 180,
          sortable: false
        }
      ],
      rows: [],
      bookingDetailStore
    }
  }
}
</script>

<style></style>
